export default "__VITE_ASSET__UumMVwAv__"